import React, { Component } from 'react'

import { TableComp } from 'sz-react-utils'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import moment from 'moment'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import { Card, Col, DatePicker, Row, Tooltip, Button, Popconfirm, notification, Tabs, Form, Drawer, Select } from 'antd'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { connect } from 'react-redux'
import commonStyle from '../../../common.less'
import setting from '../../../../components/_utils/settings'
import EditUniversity from '../../../../components/_utils/editUniversity'
import InboxRenewalMail from '../../../../components/_utils/inboxRenewalMail'
import AddAgreement from '../../../../components/_utils/addAgreement'
import { RightsWrapper } from '../../../../components/_utils/utils'
import ListFollowUp from '../../../../components/_utils/listUniversityFollowUp'
import rightAuth from '../../../../components/_utils/userRights'
import PDFFileView from '../../../../components/DocumentViews/PDFFileView'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let universityObj = {}

const { RangePicker } = DatePicker
const TabPane = Tabs.TabPane
const Option = Select.Option


class UniversityAgreements extends Component {
    state = {
        visible: true,
        ext: null,
        linkUrl: null,
        agreement: []
    }

    componentDidMount() {

    }

    apiRequest = () => {
        return new Promise(async (resolve) => {
            let { university: { _id } } = this.props;
            let response = await Request.getUniversityChannelPartners({ uniId: _id });
            this.setState({ count: response.total });
            return resolve(response);
        })
    }


    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }


    viewCommPDF = e => {
        const { paymentUploadCommissionPage } = e;
        // const { form, serviceData, partnershipArr } = this.props;
        // const { agreement } = serviceData;
        if (paymentUploadCommissionPage.length > 0) {
            let linkUrl = MEDIA_URL + paymentUploadCommissionPage[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUploadCommissionPage });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }
    viewPDF = e => {
        const { paymentUpload } = e;
        // const { form, serviceData, partnershipArr } = this.props;
        // const { agreement } = serviceData;
        if (paymentUpload.length > 0) {
            let linkUrl = MEDIA_URL + paymentUpload[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUpload });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null, agreement: [] });
    }

    render() {
        let { visible, ext, linkUrl, agreement } = this.state;
        let { university } = this.props;
        let columns = [
            {
                title: "Sr No.",
                key: 'serialNumber',
                width: 70,
                render: (text, record, index) => {
                    return (
                        <div>{index + 1}</div>
                    )
                }
            },
            {
                title: 'Channel Partner Name',
                key: 'channelPartnerName',
                dataIndex: 'channelPartnerName',
                render: (text) => text || 'N/A'
            },
            {
                title: 'Agreement Sign Date',
                key: 'agreementSigningDate',
                render: (text, record) => (
                    record && record.agreementSigningDate
                        ? moment(record.agreementSigningDate).format(dateFormat)
                        : "N/A"
                )
            },
            {
                title: 'Agreement Expire Date',
                key: 'enrollmentExpiry',
                render: (text, record) => (
                    record && record.enrollmentExpiry
                        ? moment(record.enrollmentExpiry).format(dateFormat)
                        : "N/A"
                )
            },
            {
                title: 'Commission',
                key: 'commission',
                render: (text, record) => {

                    let universityId = this.props.university._id;

                    let foundComm =
                        record &&
                            record.uniCommArr &&
                            record.uniCommArr.length
                            ? record.uniCommArr.find((obj) => {
                                return obj.universityId === universityId;
                            })
                            : null;

                    if (foundComm) {

                        // New Structure
                        if (
                            foundComm.commDetails &&
                            foundComm.commDetails.length > 0
                        ) {
                            return (
                                <div>
                                    {foundComm.commDetails.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                T{item.term ? item.term : (index + 1)}
                                                {" : "}
                                                {item.commissionFromUniversity || "-"}
                                                {" "}
                                                {item.commissionTypeFrom
                                                    ? `(${item.commissionTypeFrom})`
                                                    : ""}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        }

                        // Old Structure
                        return (
                            <div>
                                {foundComm.commissionFromUniversity > 0
                                    ? foundComm.commissionFromUniversity
                                    : null}
                                {" "}
                                {foundComm.commissionTypeFrom
                                    ? `(${foundComm.commissionTypeFrom})`
                                    : ""}
                            </div>
                        );
                    }

                    return <div>N/A</div>;
                }
            },
            {
                title: 'Agreement',
                key: 'paymentUpload',
                render: (text, record) => (
                    record &&
                        record.paymentUpload &&
                        record.paymentUpload.length > 0
                        ? (
                            <Button
                                type='primary'
                                icon='eye'
                                onClick={() => this.viewPDF(record)}
                            />
                        )
                        : "N/A"
                )
            },
            {
                title: 'Agreement Commission Page',
                key: 'paymentUploadCommissionPage',
                render: (text, record) => (
                    record &&
                        record.paymentUploadCommissionPage &&
                        record.paymentUploadCommissionPage.length > 0
                        ? (
                            <Button
                                type='primary'
                                icon='eye'
                                onClick={() => this.viewCommPDF(record)}
                            />
                        )
                        : "N/A"
                )
            }
        ];
        // let columns = [
        //     {
        //         title: "Sr No.",
        //         key: 'serialNumber',
        //         width: 70,
        //         render: (text, record, index) => {
        //             return (
        //                 <div>{index + 1}</div>
        //             )
        //         }
        //     },
        //     {
        //         title: 'Channel Partner Name',
        //         key: 'channelPartnerName'
        //     },
        //     {
        //         title: 'Agreement Sign Date',
        //         key: 'agreementSigningDate',
        //         render: (text, record) => (
        //             record && record.agreementSigningDate ?
        //                 moment(record.agreementSigningDate).format(dateFormat)
        //                 : "N/A"

        //         )
        //     },
        //     {
        //         title: 'Agreement Expire Date',
        //         key: 'enrollmentExpiry',
        //         render: (text, record) => (
        //             record && record.enrollmentExpiry ?
        //                 moment(record.enrollmentExpiry).format(dateFormat)
        //                 : "N/A"
        //         )
        //     },
        //     {
        //         title: 'Commission',
        //         key: 'commission',
        //         render: (text, record) => {
        //             let universityId = this.props.university._id;
        //             let foundComm = record && record.uniCommArr ? record.uniCommArr.find((obj) => {
        //                 return obj.universityId === universityId;
        //             }) : null;
        //             if (foundComm) {
        //                 return (
        //                     <div>{foundComm.commissionFromUniversity > 0 ? foundComm.commissionFromUniversity : null} {foundComm.commissionTypeFrom ? `(${foundComm.commissionTypeFrom})` : null}</div>
        //                 )
        //             } else {
        //                 return (
        //                     <div>N/A</div>
        //                 )
        //             }
        //         }
        //     },
        //     {
        //         title: 'Agreement',
        //         key: 'paymentUpload',
        //         render: (text, record) => (
        //             record.paymentUpload && record.paymentUpload.length > 0 ? <Button type='primary' icon='eye' onClick={() => this.viewPDF(record)} /> : "N/A"
        //         )
        //     },
        //     {
        //         title: 'Agreement Commission Page',
        //         key: 'paymentUploadCommissionPage',
        //         render: (text, record) => (
        //             record.paymentUploadCommissionPage && record.paymentUploadCommissionPage.length > 0 ? <Button type='primary' icon='eye' onClick={() => this.viewCommPDF(record)} /> : "N/A"
        //         )
        //     }
        // ];
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Agreements of {university.universityInstitutionName}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1200}
                visible={visible}>
                <Card>
                    {
                        ext != null && agreement.length > 0 ?
                            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                            : null
                    }
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class RenewServiceProviderEmail extends Component {
    state = {
        visible: true,
        loading: false,
        templateArr: [],
    }

    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('Email');
        this.setState({ templateArr })
    }

    getAllDetails = async () => {
        let { providerId } = this.props;

        let response = await Request.getServiceProviderAgreement(providerId)
        // let response = await Request.getUniversity(providerId);
        let user = localStorage.getItem('user') != 'undefined'
            ? JSON.parse(localStorage.getItem('user'))
            : null
        this.props.form.setFieldsValue({ emailFrom: user.email, emailTo: response.doc.email, providerId: providerId })
    }

    async componentDidMount() {
        this.loadSmsTemplate()
        this.getAllDetails()
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let response = await Request.sendAgreementRenewalMail(values)
                if (!response.error) {
                    notification.success({
                        message: 'Mail sent successfully'
                    });
                    this.onClose();
                } else {
                    notification.error({
                        message: response.msg,
                    })
                }
            }

        })
    }

    render() {

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { templateArr } = this.state

        const inputTypes = {
            fields: [
                {
                    label: '',
                    key: 'providerId',
                    type: 'hidden',
                },
                {
                    label: 'From',
                    key: 'emailFrom',
                    required: true
                },
                {
                    label: 'To',
                    key: 'emailTo',
                    required: true
                },
                {
                    label: 'Subject',
                    key: 'subject',
                    required: true
                },
                {
                    label: 'Choose Template',
                    key: 'templateId',
                    type: 'select',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    width: 500,
                    keyAccessor: x => x.templateData,
                    valueAccessor: x => x.templateName,
                    disabled: false,
                    options: templateArr ? templateArr : {},
                    onChange: v => {
                        this.props.form.setFieldsValue({ templateId: v })
                        this.props.form.setFieldsValue({ template: v })
                    }
                },
                {
                    label: 'Template',
                    key: 'template',
                    required: true,
                    type: 'editor',
                    rows: 15
                }
            ]
        }

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Renewal Request
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={API_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}




@Form.create()
class AddServiceProviderAgreement extends Component {
    state = {
        visible: true,
        agreement: [],
        linkUrl: '',
        loading: false,
        isAgreementExpire: false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }



    componentDidMount() {
        let { serviceData, form: { setFieldsValue } } = this.props
        if (serviceData && serviceData._id) {
            this.setState({ agreement: serviceData.agreement, isAgreementExpire: serviceData.isAgreementExpire })
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    ...serviceData,
                    agreementDate: moment(serviceData.agreementDate),
                    agreementExpiry: moment(serviceData.agreementExpiry)
                })
            }, 400)
        }
    }

    viewPDF = e => {
        const { form, serviceData, partnershipArr } = this.props;
        const { agreement } = serviceData;
        if (agreement.length > 0) {
            let linkUrl = MEDIA_URL + agreement[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }


    handleSubmit = (e) => {
        let { form, serviceData } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            let x = null
            this.setState({ loading: true })
            if (serviceData && serviceData._id) {
                values._id = serviceData._id
                x = await Request.updateServiceProviderAgreement(values)
            } else {
                x = await Request.addServiceProviderAgreement(values)
            }
            this.setState({ loading: false })
            if (x.success) {
                notification.success({
                    message: x.message
                })
            } else {
                notification.error({
                    message: x.message
                })
            }
            this.onClose()
        })
    }
    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    render() {
        let { visible, isAgreementExpire } = this.state
        let { form: { getFieldDecorator } } = this.props
        var agreement = this.state.agreement;
        var linkUrl = this.state.linkUrl;
        var ext = this.state.ext;
        let inputTypes = {
            fields: [
                {
                    label: 'Name',
                    key: 'name',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Email Address',
                    key: 'email',
                    required: true
                },
                {
                    label: 'Description',
                    key: 'description',
                    type: 'textarea',
                    required: true
                },
                {
                    label: 'Incentive Details',
                    key: 'incentiveDetails',
                    type: 'textarea',
                    required: true
                },
                {
                    label: 'Agreement Date',
                    key: 'agreementDate',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Does This Agreement has Expiry?',
                    key: 'isAgreementExpire',
                    required: true,
                    type: 'switch',
                    onChange: checked => {
                        this.setState({ isAgreementExpire: checked }, () => {
                            this.props.form.setFieldsValue({ isAgreementExpire: checked })
                        })
                    }
                },
                {
                    label: 'Agreement Expiry Date',
                    key: 'agreementExpiry',
                    type: 'date',
                    hidden: isAgreementExpire ? false : true,
                    required: isAgreementExpire ? true : false,
                },
                {
                    label: 'Upload Agreement',
                    key: 'agreement',
                    type: 'file',
                    required: true
                }
            ]
        }
        return (

            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add Service Provider Agreement
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={600}
                visible={visible}>
                <Card>
                    {
                        ext != null && agreement.length > 0 ?
                            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                            : null
                    }
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        {this.props.serviceData && this.props.serviceData._id ?
                            <Row>
                                <Col span={24}>
                                    <Button onClick={this.viewPDF}>
                                        View Agreement
                                    </Button>
                                </Col>
                            </Row>
                            : null}
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class AllAgreementManagement extends Component {
    state = {
        total: 0,
        serviceTotal: 0,
        printLoading: {},
        exportLoading: false,
        restoreLoading: false,
        showDelete: false,
        showFollowUp: false,
        editData: {},
        universityId: '',
        showEditForm: false,
        activeTab: '0',
        showAddAgreement: false,
        showRenewalInboxView: false,
        categoryArr: ['Government', 'Private', 'Not Specified', 'SPP', 'IPP', 'SVP'],
        statusArr: ['Active', 'Block', 'Expired'],
        partnershipArr: [],
        showAddServiceAgreement: false,
        serviceData: null,
        showServiceRenewalInbox: false,
        serviceId: '',
        ext: null,
        linkUrl: '',
        showAgreementDrawer: false,
        universityRecord: {}
    }


    apiServiceRequest = params => {
        return new Promise(async (resolve) => {
            this.setState({ exportParams: params });
            let data = await Request.getServiceAgreements({
                ...params,
                regExFilters: [],
                dateFilter: this.state.time
            })
            this.setState({ serviceTotal: data.total })
            resolve(data)
        })
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            this.setState({ exportParams: params });
            let searchParams = (new URL(document.location)).searchParams;
            let type = searchParams.get("type");
            if (type) {
                params.type = type
            }
            let patnerShiptype = searchParams.get("patnerShiptype");
            if (patnerShiptype) {
                params.patnerShiptype = patnerShiptype
            }
            let consortiumId = searchParams.get("consortiumId");
            if (consortiumId) {
                params.consortiumId = consortiumId
            }

            let data = await Request.getAgreementManagement({
                ...params,
                regExFilters: [
                    'universityInstitutionName',
                    'universityCity',
                    'universityPartnership',
                    'universityCategory',
                    'enrollmentAdmissionOffer',
                    'enrollmentConfirmation',
                    'courseVal',
                    'universityStatus',
                    'updatedByUser.name',
                    'createdByUser.name',
                    'paymentUpload',
                    'training'
                ],
                dateFilter: this.state.time
            })
            this.setState({ total: data.total })
            resolve(data)
        })
    }
    onLoadMore = record => {
        let tt = 0
        record.course.forEach((val, index) => {
            if (index + 1 > record.smallCourse.length && tt <= 1) {
                record.smallCourse.push(val)
                tt++
            }
        })
    }


    exportServiceExcel = async () => {
        const { exportParams } = this.state
        this.setState({ exportLoading: true })
        let x = await Request.exportServiceProviderAgreementToExcel({
            ...exportParams, regExFilters: [], dateFilter: this.state.time
        })
        this.setState({ exportLoading: false })
        if (!x.error) {
            window.open(x.url)
        }
    }

    exportExcel = async () => {
        const { exportParams } = this.state

        this.setState({ exportLoading: true })
        let x = await Request.exportUniversitiesToExcel({
            ...exportParams, regExFilters: ['universityInstitutionName'
            ]
        })
        this.setState({ exportLoading: false })

        if (!x.error) {
            window.open(x.url)
        }
    }

    openFollowUps = (record) => {
        universityObj = {
            name: record.universityInstitutionName,
            _id: record._id
        }
        this.setState({ showFollowUp: true })
    }

    closeFollowUp = () => {
        this.setState({ showFollowUp: false }, () => {
            this.table.current.reload();
        });
    };

    callback = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }
    chooseTab(value) {
        this.setState({
            activeTab: value
        })
    }

    sendRenewalMail = (recordId) => {
        this.setState({ showRenewalInboxView: true, universityId: recordId })
    }

    sendServiceRenewalMail = (serviceId) => {
        this.setState({ showServiceRenewalInbox: true, serviceId: serviceId })
    }

    closeServiceRenewalMail = () => {
        this.setState({ showServiceRenewalInbox: false, serviceId: '' })
        this.table.current.reload()
    }
    closeRenewMail = () => {
        this.setState({ showRenewalInboxView: false, showAddAgreement: false })
        this.table.current.reload()
    }
    handleAdd = () => {
        this.setState({ showAddAgreement: true })
    }

    handleAddService = () => {
        this.setState({ showAddServiceAgreement: true })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                key: 'time',
                from: date[0],
                to: date[1]
            }
        })
        if (date[0] === undefined) {
            setTimeout(() => {
                this.table.current.reload()
            }, 500)
        }
    }
    onOk = value => {
        this.table.current.reload();
    }

    handleEdit = (record) => (

        this.setState({ showEditForm: true, editData: record })
    )

    handleServiceEdit = (record) => {
        this.setState({ showAddServiceAgreement: true, serviceData: record })
    }

    handleDelete = async (id) => {
        let response = await Request.deleteUniversity({ id: id });
        if (!response.error) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
    }


    handleServiceDelete = async (id) => {
        let response = await Request.deleteServiceProviderAgreement({ id: id });
        if (!response.error) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload()
    }

    closeEditForm = () => {
        this.setState({ showEditForm: false, editData: {} });
        this.table.current.reload()
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }


    viewPDF = (record) => {
        const { paymentUpload } = record;
        if (paymentUpload.length > 0) {
            let linkUrl = MEDIA_URL + paymentUpload[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUpload })
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }


    closeShowAgreement = () => {
        this.setState({ showAgreementDrawer: false, universityRecord: {} })
    }


    closeServiceProvider = () => {
        this.setState({ showAddServiceAgreement: false, serviceData: null })
        this.table.current.reload()
    }

    closePdfDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }



    async componentDidMount() {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllUniversityPartnership(params)
        this.setState({ partnershipArr: response.data })
    }

    render() {
        const { categoryArr, showServiceRenewalInbox, statusArr, partnershipArr, showRenewalInboxView, showAddAgreement, showFollowUp } = this.state
        const serviceColumns = [
            {
                title: 'Action ',
                key: 'operation',
                dataindex: 'operation',
                fixed: 'left',
                width: 150,
                maxWidth: 150,
                render: (text, record) => (
                    <>
                        <Tooltip title="Edit Service Agreement">
                            <Popconfirm
                                title="Are you sure to Edit Details?"
                                onConfirm={() => {
                                    this.handleServiceEdit(record)
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    size={'small'}
                                    style={{ marginLeft: '5px' }}
                                    shape="circle"
                                    icon="edit"
                                />
                            </Popconfirm>
                        </Tooltip>
                        <Tooltip title="Renewal Request">
                            <Button
                                loading={false}
                                size={'small'}
                                style={{ marginLeft: '5px' }}
                                onClick={() => { this.sendServiceRenewalMail(record._id) }}
                                shape="circle"
                                icon="forward"
                            />
                        </Tooltip>
                        <RightsWrapper myRight={'AgreementManagement.delete'}>
                            <Tooltip title="Delete Agreement">
                                <Popconfirm
                                    title="Are you sure to Delete Agreement"
                                    onConfirm={() => {
                                        this.handleServiceDelete(record._id)
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        size={'small'}
                                        style={{ marginLeft: '5px' }}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </>
                )
            },
            {
                title: 'Name',
                key: 'name',
                dataIndex: 'name'
            },
            {
                title: 'Email Address',
                key: 'email',
            },
            {
                title: 'Description',
                key: 'description'
            },
            {
                title: 'Incentive Details',
                key: 'incentiveDetails'
            },
            {
                title: 'Agreement Date',
                key: 'agreementDate',
                render: (text, record) => (
                    <div>{moment(record.agreementDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Expiry Date',
                key: 'agreementExpiry',
                render: (text, record) => (
                    <div>{moment(record.agreementExpiry).format(dateFormat)}</div>
                )
            }
        ]
        const columns = [
            {
                title: 'Action ',
                key: 'operation',
                dataindex: 'operation',
                fixed: 'left',
                width: 170,
                maxWidth: 170,
                render: (text, record) => (
                    <>
                        <Tooltip title="Edit">
                            <Popconfirm
                                title="Are you sure to Edit Details?"
                                onConfirm={() => {
                                    this.handleEdit(record)
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    size={'small'}
                                    style={{ marginLeft: '5px' }}
                                    shape="circle"
                                    icon="edit"
                                />
                            </Popconfirm>
                        </Tooltip>
                        <Tooltip title="Renewal Request">
                            <Button
                                loading={false}
                                size={'small'}
                                style={{ marginLeft: '5px' }}
                                onClick={() => { this.sendRenewalMail(record._id) }}
                                shape="circle"
                                icon="forward"
                            />
                        </Tooltip>
                        {/* Delete Agreement */}
                        <RightsWrapper myRight={'AgreementManagement.delete'}>
                            <Tooltip title="Delete">
                                <Popconfirm
                                    title="Are you sure to Delete Agreement"
                                    onConfirm={() => {
                                        this.handleDelete(record._id)
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        size={'small'}
                                        style={{ marginLeft: '5px' }}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        {/* View FollowUps */}
                        <Tooltip title="View followups">
                            <Button
                                shape="circle"
                                size="small"
                                style={{ marginLeft: '5px' }}
                                onClick={() => this.openFollowUps(record)}
                                icon="eye"
                            />
                        </Tooltip>
                        {/* View Agreement */}
                        {/* <Tooltip title="View Agreement">
                            <Button
                                shape="circle"
                                size="small"
                                style={{ marginLeft: '5px' }}
                                onClick={() => this.viewPDF(record)}
                                icon="file"
                            />
                        </Tooltip> */}
                        {/* View All Agreements */}
                        {record.universityPartnership === "Channel Partner" ?
                            <Tooltip title="View All Agreements">
                                <Button
                                    shape='circle'
                                    size='small'
                                    onClick={() => this.setState({ showAgreementDrawer: true, universityRecord: record })}
                                    style={{ marginLeft: '5px' }}
                                    icon="file"
                                />
                            </Tooltip>
                            : <Tooltip title="View Agreement">
                                <Button
                                    shape="circle"
                                    size="small"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => this.viewPDF(record)}
                                    icon="file"
                                />
                            </Tooltip>}
                    </>
                )
            },
            {
                title: 'University',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName',
                width: 200,
                fixed: 'left',
                sorter: true,
                searchTextName: 'universityInstitutionName',
                filterRegex: true,
                render: (text, record) => (
                    record.universityStatus === "Expired" ? <div style={{ color: '#FF0000' }}>{text} {record.consortiumId ? `-${record.consortiumId.consortiumName}` : ""}</div> : <div>{text}{record.consortiumId ? `-${record.consortiumId.consortiumName}` : ""}</div>
                )
            },
            {
                title: 'City [Country]',
                width: 200,
                key: 'universityCity',
                searchTextName: 'universityCity',
                dataIndex: 'universityCity',
                render: (text, record) => {
                    return (
                        <span>
                            {record.universityCity} [{record.universityCountry}]
                        </span>
                    )
                }
            },
            {
                title: 'Partnership',
                key: 'universityPartnership',
                dataIndex: 'universityPartnership',
                sorter: true,
                filters: partnershipArr && partnershipArr.map(x => ({ value: x.partnershipName, text: x.partnershipName })),
                filterRegex: true,
                width: 150
            },
            {
                title: 'Channel Partners',
                key: 'channelPartnerNames',
                dataIndex: 'channelPartnerNames',
                filterRegex: true,
                width: 150,
                searchTextName: 'Channel Partner Name'
            },
            {
                title: 'Training',
                key: 'training',
                width: 90,
                render: (text, record) => (
                    record.training ? 'Yes' : 'No'
                )
            },
            {
                title: 'Category',
                key: 'universityCategory',
                dataIndex: 'universityCategory',
                sorter: true,
                // searchTextName: 'universityCategory',
                filters: categoryArr && categoryArr.map(x => ({ value: x, text: x })),
                filterRegex: true,
                width: 150
            },
            {
                title: 'Status',
                key: 'universityStatus',
                dataIndex: 'universityStatus',
                sorter: true,
                filters: statusArr && statusArr.map(x => ({ value: x, text: x })),
                filterRegex: true,
                width: 150
            },
            {
                title: 'Agreement Signing Date',
                width: 150,
                key: 'agreementSigningDate',
                render: (text, record) => {
                    return (
                        <div>
                            <small>
                                {text ? moment(text).format('lll') : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Enrollment Expiry',
                width: 150,
                key: 'enrollmentExpiry',
                render: (text, record) => {
                    return (
                        <div>
                            <small>
                                {text ? moment(text).format('lll') : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Enrollment Renewal',
                width: 150,
                key: 'enrollmentRenewal',
                render: (text, record) => {
                    return (
                        <div>
                            <small>
                                {text ? moment(text).format('lll') : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'Updated By',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                dataIndex: 'createdByUser',
                searchTextName: 'Created',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            }
        ]
        return (
            <PageHeaderWrapper title={`Agreements Management`}>
                {
                    this.state.showAgreementDrawer ?
                        <UniversityAgreements university={this.state.universityRecord} onClose={this.closeShowAgreement} />
                        : null
                }
                {
                    this.state.ext != null && this.state.agreement.length > 0 ?
                        <PDFFileView linkUrl={this.state.linkUrl} ext={this.state.ext} onClose={this.closePdfDocument} />
                        : null
                }
                {
                    showServiceRenewalInbox ?
                        <RenewServiceProviderEmail providerId={this.state.serviceId} onClose={this.closeServiceRenewalMail} />
                        : null
                }
                {
                    this.state.showAddServiceAgreement ?
                        <AddServiceProviderAgreement serviceData={this.state.serviceData} onClose={this.closeServiceProvider} />
                        : null
                }
                {
                    this.state.showEditForm ? (
                        <EditUniversity data={this.state.editData} onClose={this.closeEditForm} partnershipArr={partnershipArr} />
                    ) : null
                }
                {
                    showRenewalInboxView ? (
                        <InboxRenewalMail universityId={this.state.universityId} onClose={this.closeRenewMail} />
                    ) : null
                }
                {
                    showAddAgreement ? (
                        <AddAgreement onClose={this.closeRenewMail} />
                    ) : null
                }
                {
                    showFollowUp ? (
                        <ListFollowUp universityObj={universityObj} onClose={this.closeFollowUp} />
                    ) : null
                }

                <Card style={{ marginBottom: 10 }}>
                    <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                        <TabPane tab={`University Agreements`} key={0}>
                            <h2>{`Total : ${this.state.total}`}</h2>
                            <Row>
                                <Col span={14}>
                                    <h4>FILTER BY LAST UPDATE</h4>
                                    <RangePicker
                                        showTime={{ format: 'HH:mm' }}
                                        format="YYYY-MM-DD HH:mm"
                                        placeholder={['Start Time', 'End Time']}
                                        onChange={this.chooseRangerPicker}
                                        onOk={this.onOk}
                                    />
                                </Col>
                                <Col span={5}>
                                    <h4>FILTER BY STATUS</h4>
                                    <Select allowClear placeholder="Select Status" style={{ width: '90%' }}>
                                        <Option value="Pending">Pending</Option>
                                        <Option value="Active">Active</Option>
                                        <Option value="Block">Block</Option>
                                        <Option value="Expired">Expired</Option>
                                    </Select>
                                </Col>
                                <Col span={3}>
                                    <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                        {
                                            rightAuth.checkRights("AgreementManagementExcelExport.view") ?
                                                <Button type={'default'}
                                                    loading={this.state.exportLoading}
                                                    onClick={() => {
                                                        this.exportExcel()
                                                    }}>Export Excel</Button>
                                                : null
                                        }
                                    </div>
                                </Col>
                                <RightsWrapper myRight={'AgreementManagement.add'} >
                                    <Col span={2}>
                                        <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                            <Button onClick={this.handleAdd}>Add</Button>
                                        </div>
                                    </Col>
                                </RightsWrapper>
                            </Row>
                            <Card bordered={true} style={{ marginTop: 10 }}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={this.apiRequest}
                                    extraProps={{ scroll: { x: 1400 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 20,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        <TabPane tab={`Service Provider Agreements`} key={1}>
                            <h2>{`Total : ${this.state.serviceTotal}`}</h2>
                            <Row>
                                <Col span={14}>
                                    <h4>FILTER BY LAST UPDATE</h4>
                                    <RangePicker
                                        showTime={{ format: 'HH:mm' }}
                                        format="YYYY-MM-DD HH:mm"
                                        placeholder={['Start Time', 'End Time']}
                                        onChange={this.chooseRangerPicker}
                                        onOk={this.onOk}
                                    />
                                </Col>
                                <Col span={3}>
                                    <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                        {
                                            rightAuth.checkRights("AgreementManagementExcelExport.view") ?
                                                <Button type={'default'}
                                                    loading={this.state.exportLoading}
                                                    onClick={() => {
                                                        this.exportServiceExcel()
                                                    }}>Export Excel</Button>
                                                : null
                                        }
                                    </div>
                                </Col>
                                <RightsWrapper myRight={'AgreementManagement.add'} >
                                    <Col span={2}>
                                        <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                            <Button onClick={this.handleAddService}>Add</Button>
                                        </div>
                                    </Col>
                                </RightsWrapper>
                            </Row>
                            <Card bordered={true} style={{ marginTop: 10 }}>
                                <TableComp
                                    ref={this.table}
                                    columns={serviceColumns}
                                    apiRequest={this.apiServiceRequest}
                                    extraProps={{ scroll: { x: 1400 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 20,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                    </Tabs>
                </Card>

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllAgreementManagement)
